import React from "react";
import DatePicker from "react-datepicker";
import "./styles/PatientTable.css";

const PatientTable = ({
  patientName,
  setPatientName,
  patientDOB,
  setPatientDOB,
  patientSex,
  setPatientSex,
  patientID,
  setPatientID,
  orderBy,
  setOrderBy,
  reportRecipient,
  setReportRecipient,
  amendedNotes,
  setAmendedNotes,
  contactInfo,
  setContactInfo,
}: any) => {
  return (
    <div className="patient-table">
      {/* Patient Info */}
      <div className="box patient-info-box">
        <div className="box-header">
          <span>Patient information</span>
          <div className="bottom-line"></div>
        </div>
        <div className="box-content">
          <div className="field-group-1">
            <div className="field name-field">
              <label>Name:</label>
              <input
                type="text"
                value={patientName}
                onChange={e => setPatientName(e.target.value)}
                placeholder="Jones, Mary R"
              />
            </div>
            <div className="field sex-field">
              <label>Sex:</label>
              <select
                value={patientSex}
                onChange={e => setPatientSex(e.target.value)}
              >
                <option value="F">F</option>
                <option value="M">M</option>
                <option value="O">O</option>
              </select>
            </div>
          </div>
          
          <div className="field-group-2">
            <div className="field dob-field">
              <label>Date of birth:</label>
              <div className="date-picker-wrapper">
                <DatePicker
                  selected={patientDOB}
                  onChange={(d: Date) => setPatientDOB(d)}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/DD/YYYY"
                  className="date-picker-input"  // Optional class for extra customization
                />
              </div>
            </div>
            <div className="field id-field">
              <label>Patient ID:</label>
              <input
                type="text"
                value={patientID}
                onChange={e => setPatientID(e.target.value)}
                placeholder="12345678910"
              />
            </div>
          </div>

        </div>

        <div className="box note-box">
          <div className="box-header">
            <span>Note</span>
            <div className="bottom-line"></div>
          </div>
          <div className="box-content">
            <textarea
              value={amendedNotes}
              onChange={e => setAmendedNotes(e.target.value)}
              placeholder="Amended Note"
            />
          </div>
        </div>
      </div>


      {/* Report Recipient */}
      <div className="box-right">
        <div className="box report-box">
          <div className="box-header">
            <span>Report recipient</span>
            <div className="bottom-line"></div>
          </div>
          <div className="box-content">
            <div className="field">
              <label>Ordered by: </label>
              <input
                type="text"
                className="custom-input"
                placeholder="Enter Name"
                value={orderBy}
                onChange={(e) => setOrderBy(e.target.value)}
              />
            </div>
            <div className="report-and-contact">
              <textarea
                value={reportRecipient}
                onChange={e => setReportRecipient(e.target.value)}
                placeholder={`Example Physician Office
555 Example Street
Suite 101
City, State 99999 US`}
              />
              <textarea
                value={contactInfo}
                onChange={e => setContactInfo(e.target.value)}
                placeholder={`Phone: 555-555-3456
Fax: 555-555-3456`}
              />
            </div>

          </div>
        </div>
      </div>


      {/* Contact Info */}
      {/* <div className="box contact-box">
        <div className="box-header">
          <span>Contact info:</span>
          <div className="bottom-line"></div>
        </div>
        <div className="box-content">
          <textarea
            value={contactInfo}
            onChange={e => setContactInfo(e.target.value)}
            placeholder={`Phone: 555-555-3456
Fax: 555-555-3456`}
          />
        </div>
      </div> */}
    </div>
  );
};

export default PatientTable;
